export interface PARAMS {
  [key: string]: string | string[] | null;
}

const sanitizeParams = (params: PARAMS) =>
  Object.entries(params).reduce((acc: PARAMS, [key, value]) => {
    if (!params[key]) return acc;

    acc[key] = value;

    return acc;
  }, {});

export default sanitizeParams;
